/**
 * Dove mandare chi apre la radice '/'.
 *
 * Due domini, due utenti diversi:
 * - dominio neutro (clblnk.it): chi atterra e' un utente pubblico. Vince il
 *   publicPath salvato (PWA installata da /clienti-pubblico/<token>: il browser
 *   apre '/' e va riportato alla pagina condivisa) e non si manda MAI al login.
 * - app.clabnet.it: chi apre '/' e' un operatore. Vince l'ultima pagina
 *   dell'app; il publicPath resta solo come fallback.
 *
 * Regressione 2026-08-26: il publicPath aveva la precedenza assoluta su
 * entrambi i domini. Siccome viene scritto ad ogni apertura di una pagina
 * pubblica — anche quando e' l'operatore a controllare il link di un cliente —
 * e non viene mai cancellato, la radice di app.clabnet.it restava incastrata
 * per sempre sulla pagina di quel cliente.
 */

export const LAST_PATH_KEY = 'clab.lastPath';
export const PUBLIC_PATH_KEY = 'clab.publicPath';
// Archivio e' un'app a se' (/archivio, icona propria): non entra nell'ultima
// pagina di C-LAB, altrimenti l'icona di C-LAB riaprirebbe l'Archivio. Il flag
// in sessionStorage (per finestra) serve al login per tornare li'.
export const ARCHIVIO_SESSION_KEY = 'clab.archivio';

// Route che non sono una destinazione utile: ripartire da qui sarebbe un giro
// a vuoto sulla radice o sul login.
export const SKIP_PATHS = new Set(['/', '/login']);

const usable = (path) => (path && !SKIP_PATHS.has(path) ? path : null);

/**
 * Ritorna il path su cui redirigere, oppure null quando non c'e' destinazione
 * sensata (solo dominio neutro: il chiamante mostra "Link non valido").
 */
export function rootTarget({ publicPath, last, isPublicHost }) {
  const toPublic = usable(publicPath);
  if (isPublicHost) return toPublic;
  return usable(last) || toPublic || '/login';
}
